module.exports = __webpack_public_path__ + "static/media/gado.81245c81.jpg";